import * as React from 'react';
import * as styles from './ContentCreatorAdmin.css';
import { IAIcon } from '../icon/Icon';
import { IACommandBar } from '../commandBar/CommandBar';
import { IAButton } from '../button/Button';
import { ContentCreatorItem } from './contentCreatorItem/ContentCreatorItem';
import { ContentCreatorStore } from './stores';
import { inject, observer } from 'mobx-react';
import { EditPanel } from './editPanel/EditPanel';
import { IContentCreatorItem } from '../../interfaces/IContentCreatorItem';
import { Helper } from '../../Helper';
import { IAPopup } from '../popup/Popup';
import { LocalizationService } from '../../services/LocalizationService';
import { IASkeleton } from '../skeleton/Skeleton';

export interface IProps {
  contentCreatorStore?: ContentCreatorStore;
}

export interface IState {
}

@inject('contentCreatorStore')
@observer
export class ContentCreatorAdmin extends React.Component<IProps, IState> {

  private cancelPopupId;

  constructor(props: IProps) {
    super(props);
    this.state = {
    };
    this.cancelPopupId = Helper.getRandomStringKey();
  }

  public render(): JSX.Element {
    let elements = [];
    if (this.props.contentCreatorStore.loading) {
      for (let i = 0; i < 4; i++) {
        elements.push(
          <IASkeleton
            key={i}
            skeleton={{
              height: 50,
              width: 520,
              marginBottom: 20,
              borderRadius: 5
            }}
          />
        );
      }
    } else if (!this.props.contentCreatorStore.loading && this.props.contentCreatorStore.items.length > 0) {
      elements = [];
      this.props.contentCreatorStore.items.forEach((button: IContentCreatorItem, index) => {
        elements.push(
          <ContentCreatorItem
            key={`AddNewButton_${index}`}
            color={this.props.contentCreatorStore.highlightColor}
            icon={button.icon}
            title={button.title}
            description={button.description}
            index={index}
          />
        )
      });
    } else {
      elements = [];
      elements.push(
        <div className={styles.IA_noContent}>
          <IAIcon
            title="Info"
            size={25}
            color={"#999999"}
          />
          {new LocalizationService().strings.ContentCreator_NoContent}
        </div>
      );
    }
    return (
      <div>
        <div id={`cancelPopupId_${this.cancelPopupId}`}>
          {this.props.contentCreatorStore.showCancelEditPopup &&
            <IAPopup
              headline={new LocalizationService().strings.Messages_CancelPopup_Headline}
              content={
                <div>
                  <IAButton
                    label={new LocalizationService().strings.Messages_CancelPopup_Yes}
                    buttonColor={this.props.contentCreatorStore.highlightColor}
                    showSpinner={false}
                    onClick={() => {
                      this.props.contentCreatorStore.items[this.props.contentCreatorStore.itemToEditIndex] = this.props.contentCreatorStore.itemToEditOriginal;
                      this.props.contentCreatorStore.itemToEditOriginal = undefined;
                      this.props.contentCreatorStore.itemToEdit = undefined;
                      this.props.contentCreatorStore.itemToEditIndex = undefined;
                      this.props.contentCreatorStore.isCreatingNewItem = false;
                      this.props.contentCreatorStore.availableInstancesForComponent = undefined;
                      this.props.contentCreatorStore.availableCategoriesForComponent = undefined;
                      this.props.contentCreatorStore.showCancelEditPopup = false;
                      document.body.style.overflowY = "auto";
                      document.body.style.height = "inherit";
                      this.forceUpdate();
                    }}
                    borderRadius={5}
                    style={{
                      marginTop: 20,
                      float: "left"
                    }}
                  />
                  <IAButton
                    label={new LocalizationService().strings.Messages_CancelPopup_No}
                    buttonColor={"#999999"}
                    showSpinner={false}
                    onClick={() => {
                      this.props.contentCreatorStore.showCancelEditPopup = false;
                    }}
                    borderRadius={5}
                    style={{
                      marginTop: 20,
                      marginLeft: 10,
                      float: "left"
                    }}
                  />
                </div>
              }
              close={() => {
                this.props.contentCreatorStore.showCancelEditPopup = false;
              }}
            />
          }
        </div>
        <EditPanel
          open={!!this.props.contentCreatorStore.itemToEdit}
        />
        <IACommandBar
          highlightColor={this.props.contentCreatorStore.highlightColor}
          leftSideContent={
            <IAButton
              label={new LocalizationService().strings.Messages_Add}
              buttonColor="transparent"
              textColor="#333333"
              icon="Add"
              height={22}
              iconColor={this.props.contentCreatorStore.highlightColor}
              fontSize={14}
              onClick={() => {
                this.props.contentCreatorStore.createNewItem();
              }}
            />
          }
          showBar={true}
        />
        <div className={styles.IA_elements}>
          {elements}
        </div>
      </div>
    );
  }

  
}